import { EParentAutomationKind } from "@frontend-shared/types";
import { Bot, type LucideIcon, Webhook, Workflow, Zap } from "lucide-react";

// NOTE: NSAI-7883 — the parent line's icon follows the parent's kind, as the
// child rows do.
export const PARENT_KIND_ICONS: Readonly<
  Record<EParentAutomationKind, LucideIcon>
> = {
  [EParentAutomationKind.AGENT]: Bot,
  [EParentAutomationKind.WORKFLOW]: Workflow,
  [EParentAutomationKind.WEBHOOK]: Webhook,
  [EParentAutomationKind.EVENT_RULE]: Zap,
};
